<template>
  <div>
    <v-app-bar color="primary"
      dark
      clipped-left
      clipped-right
      app
      :absolute="!fixed"
      :fixed="fixed"
      :extended="extended"
      :extension-height="extensionHeight"
    >
      <slot slot="extension" name="header-extension" />
      <router-link
        tag="div"
        class="logo-link"
        :to="{ name: logoRouteName }"
      >
        <img src="@/assets/BDA_Logo.svg" height="32px" title="Go to Main page">
      </router-link>
      <v-toolbar-title class="hidden-xs-only text-uppercase ml-2">
        <h3>{{ applicationName }}</h3>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <slot name="actions" />
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Auth from '@/store/modules/auth/constants';
import RolesHelper from '@/helpers/rolesHelper';

export default {
  name: 'headerToolbar',
  created() {
    if (this.isAuthorized) {
      this.getUserInfo();
    }
  },
  data() {
    return {
      applicationName: 'Supplier Approval Tool',
    };
  },
  computed: {
    ...mapState({
      isAuthorized: state => state.auth.isAuthorized,
    }),
    ...mapGetters('auth', {
      mainRole: Auth.getterTypes.mainRole,
    }),
    logoRouteName() {
      return RolesHelper.getRoleLogoRouteName([this.mainRole]);
    },
  },
  methods: {
    ...mapActions('auth',
      {
        getUserInfo: Auth.actionTypes.getUserInfo,
      }),
  },
  props: {
    extended: Boolean,
    extensionHeight: String,
    fixed: Boolean,
  },
};
</script>

<style lang="scss">
  .logo-link{
    cursor: pointer;
  }
</style>
